import React from 'react';
import { useSelector } from 'react-redux';

import ColorBullet from 'common/ColorBullet';
import { getActiveScenario } from 'advanced/scenarios/scenarioSelectors';
import { getMessage } from 'util/locale';
import { inferUnit } from 'util/unitConversion';
import { sortByArea } from 'util/sort';
import COLORS from 'constants/colors';

const ByZonesGraphLabel = () => {
  const { zones } = useSelector(getActiveScenario);
  
  const zonesBullets = Object.values(zones).sort(sortByArea).map((zone, index) => (
    <ColorBullet key={zone.meta.zoneId} color={COLORS.scenarios[`zone-${index + 1}-bullet`]}/>
  ));

  return (
    <section className='by-zones-graph-label'>
      <div>
        <p>{zonesBullets}{getMessage('by-zone-density')}</p>
        <p>
          <ColorBullet color={COLORS.scenarios['recommendation-bullet']}/>
          {getMessage('text__fieldview-seed-scripts')}
        </p>
        <p>
          <ColorBullet color={COLORS.scenarios['newPlan-bullet']}/>
          {getMessage('new-plan')}
        </p>
      </div>
      <p>{getMessage('planting-rate', { seedDensityUnit: inferUnit('seed-density').symbol.quantitySpecific })}</p>
    </section>
  );
};

export default ByZonesGraphLabel;
